export function groupBy(value, buildKey) {
    const result = {};
    for (const item of value) {
        const key = buildKey(item);
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(item);
    }
    return result;
}
//# sourceMappingURL=groupBy.js.map